import React from 'react';
import Seo from '../components/Seo';
import { PAGE_COPY } from '../data/seoContent';
import { motion } from 'framer-motion';
import PDCProductSection from '../components/PDCProductSection';
import CallForPricingGrid from '../components/CallForPricingGrid';
import { CLEARWATER_HOT_TUBS } from '../data/clearwaterSpas';
import { PDC_SPAS_PRODUCTS } from '../data/pdcSpas';
import { itemListLd } from '../data/structuredData';
import { VideoBlock } from '../components/VideoBlock';
import { VIDEOS } from '../data/mediaAssets';
import { REELS } from '../data/reels';
import SocialPostBanner from '../components/SocialPostBanner';

const HotTubsPage = () => {
  return (
    <>
      <Seo page="/hot-tubs" jsonLd={itemListLd('Hot tubs in Naples, FL', '/hot-tubs', [
        ...PDC_SPAS_PRODUCTS.filter((p) => p.category === 'hot-tubs').map((p) => ({ brand: 'PDC Spas', name: p.name, url: `/pdc-spas/${p.id}`, image: p.images?.[0] })),
        ...CLEARWATER_HOT_TUBS.map((p) => ({ brand: 'ClearWater Spas', name: p.name, url: '/clearwater-spas', image: p.image })),
      ])} />
    <div className="pt-36 pb-20" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)' }} data-testid="hot-tubs-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold uppercase text-[#0E3D95] mb-4">
            Hot Tubs in Naples, FL
          </h1>
          <p className="text-lg text-slate-600 max-w-4xl" data-testid="page-intro">
            {PAGE_COPY.hotTubs}
          </p>
        </motion.div>

        {/* PDC Spas Section */}
        <section className="mb-16">
          <PDCProductSection
            category="hot-tubs"
            heading="PDC Spas"
            blurb="American-made luxury hot tubs across the Luxury, Premium and LifeStyle collections — up to 143 hydrotherapy jets and a 35-year structural warranty. Click any model to explore colors and finishes."
          />
        </section>

        <CallForPricingGrid
          eyebrow="Clearwater Spas"
          title="Clearwater Spas Hot Tubs"
          subtitle="Resort, Beachcraft, Northwest, Fourwinds and plug-and-play Starlight series — click any model for photos, specs and standard features."
          items={CLEARWATER_HOT_TUBS}
          testId="clearwater-hot-tubs"
        />

        {/* Hot Tub Benefits Video Section */}
        <VideoBlock
          eyebrow="Health & Wellness"
          title="Hot Tub Benefits"
          subtitle="Discover the amazing health and wellness benefits that come with owning a hot tub."
          reel={REELS.hotTubBenefits}
          testId="hot-tub-benefits-video"
        />

        {/* Hot tub transformation reel */}
        <VideoBlock
          eyebrow="From Stressed To Serene"
          title="The Hot Tub Transformation"
          subtitle="20 minutes of warm-water hydrotherapy is all it takes to melt the day away."
          src={VIDEOS.bearHotTub}
          reel={REELS.bear}
          testId="hottub-bear-video"
        />

        {/* Matched brand graphics */}
        <SocialPostBanner ids={['dog-hot-tub', 'bear']} />
      </div>
    </div>
    </>
  );
};

export default HotTubsPage;
